/**
 * Helper function to set a property on a state object in reducers
 *
 * Example usage:
 * ```
 * const setLocale = setStateProperty('locale');
 * const updatedState = setLocale(state, 'en');
 * // in rxbeach
 * reducer(locale$, setStateProperty('locale')),
 * ```
 */
export const setStateProperty = <Key extends string>(key: Key) => {
  return function setStatePropertySetter<
    State extends { [T in Key]: State[T] },
  >(state: State, value: State[Key]): State {
    return { ...state, [key]: value };
  };
};
